import { useMutation } from '@tanstack/react-query';

import ProductsService, {
  DownloadProductSeoCSVDto,
} from '@/services/ProductsService';

export function useDownloadProductSeoCSV() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (downloadProductSeoCSVDto: DownloadProductSeoCSVDto) =>
      ProductsService.downloadProductSeoCSV(downloadProductSeoCSVDto),
  });

  return {
    downloadProductSeoCSV: mutateAsync,
    isLoading: isPending,
  };
}
